module.exports = __webpack_public_path__ + "img/btn_ip_plus.c00b4383.svg";